import "./Contactanos.css"
import TitleDisplayerComponent from "../TitleDisplayer/titledisplayer";
import React, { useState } from 'react';
import { Button, TextField } from "@mui/material";
import emailjs from 'emailjs-com';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import { FaFacebook } from 'react-icons/fa'
import { FaInstagram } from 'react-icons/fa'
import { useInView } from "react-intersection-observer";
function Contactanos() {

    const {ref:txtContactanos, inView: txtContactanosIsVisible} = useInView({
        "threshold":.75,
        "initialInView":true
    })

    const [nombre, setNombre] = useState("");
    const [telefono, setTelefono] = useState("");
    const [email, setEmail] = useState("");
    const [mensaje, setMensaje] = useState("");

    const send = () => {
        const objetoFormulario = {
            nombre, telefono, email, mensaje
        }
        emailjs.send('service_sv57t8f', 'template_4tv8ewf', objetoFormulario, 'egseznZckZwV9jR6G').then(res => {
            console.log(res);
        })

    }

    return (<>

        <div className="CContentWrap" id="contacto">
            <div className="ContactanosFlexWrap">
                <div className="ContactWrap">
                    
                    <div class="mapBox">
                        <iframe className="ImgMap" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3592.3008839055183!2d-108.99473559000292!3d25.793645877237296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86ba2f6dc1537c9d%3A0x53aba7bb8b6b10f5!2sSolar%20Serdan!5e0!3m2!1ses-419!2smx!4v1686718998696!5m2!1ses-419!2smx"
                            height="500px" width="600px" style={{ border: "0", borderRadius: "0 50px 0 0", marginRight: "2" + 'em' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" ></iframe>
                    </div>

                    <div class="txtWrapperContactact">
                        <div className="ContentContactForm">
                            <TitleDisplayerComponent text={"Contacto"} />
                            <div ref={txtContactanos} className={`formWrap ${txtContactanosIsVisible ? "formWrapAnimated" : ""} `}>
                                <div class="formInputContent">
                                    <div class="inputWrap">
                                        <TextField className="textInput" fullWidth id="Nombre" label="Nombre" variant="outlined" required onChange={(e) => { setNombre(e.target.value) }} />
                                    </div>
                                    <div class="inputWrap">
                                        <TextField className="textInput" fullWidth id="Telefono" label="Telefono" variant="outlined" required onChange={(e) => { setTelefono(e.target.value) }} />
                                    </div><div class="inputWrap">
                                        <TextField className="textInput" fullWidth id="Email" label="E-mail" variant="outlined" required onChange={(e) => { setEmail(e.target.value) }} />
                                    </div><div class="inputWrap">
                                        <TextField className="textInput" fullWidth id="Mensaje" label="Mensaje" variant="outlined" required onChange={(e) => { setMensaje(e.target.value) }} />
                                    </div>
                                    <div className="wrapSend">
                                        <Button type="submit" variant="contained" onClick={send}>Enviar</Button>
                                    </div>
                                </div>
                                <div className="ContentInformacion">
                                    <div class="sep-content-info">
                                        <div className="wrap-info">
                                            <h3>Teléfonos</h3>
                                        </div>
                                        <div className="wrap-info">
                                            <FontAwesomeIcon icon={faPhoneVolume}style={{ width: "20px", height: "20px" }}className="iconInfo" /><h4>6688562647</h4> </div>
                                        <div className="wrap-info">
                                            <img src="./Images/whatsapp.png" style={{ width: "30px", height: "30px" }} className="iconInfo"/><h4>6688562647</h4></div></div>
                                    <div class="sep-content-info">
                                        <h3>E-mail</h3>
                                    <h4>ventas@gruposerdan.com.mx</h4>
                                    </div>
                                    <div class="sep-content-info">
                                    <h3>¡Síguenos!</h3>
                                    <div className="wrap-info">
                                        <FaFacebook color="blue" style={{ width: "30px", height: "30px" }} className="iconInfo"/> <h4>/GrupoSerdán</h4></div>
                                    <div className="wrap-info">
                                        <FaInstagram style={{ width: "30px", height: "30px" }}className="iconInfo" /> <h4>/grupo.serdan</h4></div>
                                        </div>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>
        </div>

    </>
    );
}


export default Contactanos;